export const defaultSize = "m";
export const defaultScale = 1;
